// src/admin/pages/Dashboard/components/process/ProcessTable.js
import React from "react";
import { useMediaQuery } from "react-responsive";

/**
 * Mostra una tabella (o card layout su mobile) con:
 * - Order ID
 * - Data e Ora (estratte da row.sent_to_kitchen_at)
 * - Session, Table, Dish
 * - Queue, Prep, Delivery, Total (in minuti)
 */
export default function ProcessTable({ rawData }) {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  if (!rawData || rawData.length === 0) {
    return <div style={styles.noData}>Nessun ordine trovato.</div>;
  }

  // Layout Desktop
  if (!isMobile) {
    return (
      <div style={styles.tableContainer}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th>Order ID</th>
              <th>Date</th>
              <th>Time</th>
              <th>Session</th>
              <th>Table</th>
              <th>Dish</th>
              <th>Queue (min)</th>
              <th>Prep (min)</th>
              <th>Delivery (min)</th>
              <th>Total (min)</th>
            </tr>
          </thead>
          <tbody>
            {rawData.map((row, i) => {
              // Ricaviamo data/ora da sent_to_kitchen_at
              const dateObj = row.sent_to_kitchen_at
                ? new Date(row.sent_to_kitchen_at)
                : null;

              // Formattazione "breve" it-IT => es. 31/12/2023
              const datePart = dateObj
                ? new Intl.DateTimeFormat("it-IT", {
                    dateStyle: "short",
                  }).format(dateObj)
                : "-";

              // Formattazione ora "breve" => es. 14:05
              const timePart = dateObj
                ? new Intl.DateTimeFormat("it-IT", {
                    timeStyle: "short",
                  }).format(dateObj)
                : "-";

              // Converto i tempi in minuti
              const qMin = row.time_queue_sec
                ? (row.time_queue_sec / 60).toFixed(1)
                : "-";
              const pMin = row.time_prep_sec
                ? (row.time_prep_sec / 60).toFixed(1)
                : "-";
              const dMin = row.time_delivery_sec
                ? (row.time_delivery_sec / 60).toFixed(1)
                : "-";
              const tMin = row.time_total_sec
                ? (row.time_total_sec / 60).toFixed(1)
                : "-";

              return (
                <tr key={i}>
                  <td>{row.order_id}</td>
                  <td>{datePart}</td>
                  <td>{timePart}</td>
                  <td>{row.table_session_id ?? "-"}</td>
                  <td>{row.table_number ?? "-"}</td>
                  <td>{row.menu_item_name ?? "-"}</td>
                  <td>{qMin}</td>
                  <td>{pMin}</td>
                  <td>{dMin}</td>
                  <td>{tMin}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  // Layout Mobile => card
  return (
    <div>
      {rawData.map((row, i) => {
        const dateObj = row.sent_to_kitchen_at
          ? new Date(row.sent_to_kitchen_at)
          : null;

        const datePart = dateObj
          ? new Intl.DateTimeFormat("it-IT", {
              dateStyle: "short",
            }).format(dateObj)
          : "-";

        const timePart = dateObj
          ? new Intl.DateTimeFormat("it-IT", {
              timeStyle: "short",
            }).format(dateObj)
          : "-";

        const qMin = row.time_queue_sec
          ? (row.time_queue_sec / 60).toFixed(1)
          : "-";
        const pMin = row.time_prep_sec
          ? (row.time_prep_sec / 60).toFixed(1)
          : "-";
        const dMin = row.time_delivery_sec
          ? (row.time_delivery_sec / 60).toFixed(1)
          : "-";
        const tMin = row.time_total_sec
          ? (row.time_total_sec / 60).toFixed(1)
          : "-";

        return (
          <div key={i} style={styles.card}>
            <div style={styles.cardHeader}>Order #{row.order_id}</div>
            <div style={styles.cardContent}>
              <p>
                <strong>Date:</strong> {datePart}
              </p>
              <p>
                <strong>Time:</strong> {timePart}
              </p>
              <hr />
              <p>
                <strong>Session:</strong> {row.table_session_id ?? "-"}
              </p>
              <p>
                <strong>Table:</strong> {row.table_number ?? "-"}
              </p>
              <p>
                <strong>Dish:</strong> {row.menu_item_name ?? "-"}
              </p>
              <hr />
              <p>Queue: {qMin} min</p>
              <p>Prep: {pMin} min</p>
              <p>Delivery: {dMin} min</p>
              <p>Total: {tMin} min</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}

const styles = {
  noData: {
    padding: "1rem",
    color: "#444",
  },
  tableContainer: {
    width: "100%",
    overflowX: "auto",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  card: {
    backgroundColor: "#fff",
    borderRadius: "8px",
    marginBottom: "1rem",
    boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
    padding: "1rem",
  },
  cardHeader: {
    fontWeight: "bold",
    color: "#FF6600",
    marginBottom: "0.5rem",
  },
  cardContent: {
    color: "#333",
  },
};
